import { HttpErrorResponse } from '@angular/common/http';

export class AcumaticaError {
    message: string;
    exceptionType: string | undefined;
    stackTrace: string[] | undefined;

    constructor(public exception?: any, primaryMessage?: string) {
        this.message = primaryMessage || exception.exceptionMessage || exception.message;
        if (exception.exceptionType) this.exceptionType = exception.exceptionType;
        if (exception.stackTrace) this.stackTrace = (<string>exception.stackTrace)
            .split("\r\n")
            .map(item => item.trim());
    }

    static getTypedError(error: HttpErrorResponse) {
        console.error(error);
        if (error.status === 0) {
            return new UnknownError(error);
        } else if (error.status === 401) {
            return new NotLoggedInError(error);
        } else if (error.status === 422) {
            return new UnprocessableEntityError(error);
        } else if (error.status == 429) {
            let err = new TooManyRequestsError(error);
            err.message = 'Error: Too Many Server Requests -- Please wait 5 minutes then try again';
            return err;
        } else {
            console.error(error);
            let exception = error.error || error;
            let message = exception?.exceptionMessage || exception?.message;

            let matches = message && message.match(/PX.Data.PXActionDisabledException: Error: (.+)\r\n/);
            if (matches) {
                return new ActionDisabledError(exception, matches[1]);
            } else {
                switch (message) {
                    case "The request is invalid":
                        return new InvalidRequestError(exception);
                    case "You are not logged in.":
                        return new NotLoggedInError(exception);
                    case "Error: Invalid credentials. Please try again.":
                        return new InvalidLoginError(exception);
                    case "Error: Your account is locked out. Please contact your system administrator.":
                        return new AccountLockedOutError(exception);
                    case "API Login Limit":
                        return new APILoginLimitError(exception);
                    case "No entity satisfies the condition.":
                        return new NotFoundError(exception);
                    case "Operation failed":
                        // "The Create Shipment button is disabled"
                        exception.exceptionMessage = "Operation failed\n" + exception.innerException.exceptionMessage;
                        return new AcumaticaError(exception);
                    default:
                        return new AcumaticaError(exception);
                }
            }
        }
    }
}

export class UnknownError extends AcumaticaError { }
export class InvalidRequestError extends AcumaticaError { }
export class NotLoggedInError extends AcumaticaError { }
export class InvalidLoginError extends AcumaticaError { }
export class AccountLockedOutError extends AcumaticaError { }
export class APILoginLimitError extends AcumaticaError { }
export class NotFoundError extends AcumaticaError { }
export class ActionDisabledError extends AcumaticaError { }
export class TooManyRequestsError extends AcumaticaError { }
export class UnprocessableEntityError extends AcumaticaError {
    constructor(exception?: any, primaryMessage?: string) {
        super(exception, primaryMessage);

        let entity = exception.error;

        // recursive function to pull out errors
        // may be field-specific {.., field:{"value":..., "error":"message"}, ..}
        // or at entity level {.., "error":"message", .. }
        let errorScanner = (entity: any) => {
            Object.keys(entity).forEach(key => {
                if (entity[key] === null) return;
                if (key === 'error') {
                    this._fieldErrors.push(entity.error);
                }
                else if (Array.isArray(entity[key])) {
                    entity[key].forEach(errorScanner);
                }
                else if (typeof entity[key] === 'object' && entity[key].error) {
                    this._fieldErrors.push(entity[key].error);
                }
            });
        }

        errorScanner(entity);
    }

    _fieldErrors: string[] = [];
    get fieldErrors(): string[] {
        return this._fieldErrors;
    }
}

export class CancelActionError extends Error { }
export class CustomerOnCreditHoldError extends Error { }